import type { HTMLAttributes } from "react";

import { cn } from "@/lib/helpers/cn";
import { Heading2 } from "@/ui2/atoms/Heading";

export function SignatureField({
  caption,
  children,
  className,
  label,
  ...rest
}: HTMLAttributes<HTMLLIElement> & { caption?: string; label: string }) {
  return (
    <li className={cn("tw:flex tw:flex-col", className)} {...rest}>
      <Heading2 as="h4" size={1}>
        {label}
      </Heading2>

      {children}

      <span className="tw:mt-0.5 tw:text-sm tw:text-text-primary">{caption}</span>
    </li>
  );
}
